import {lookup} from "country-data";

const checkImgExists = (imgurl) => {
  var ImgObj = new Image() // 判断图片是否存在
  ImgObj.src = imgurl
  if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
    return true
  }
  return false
}
const compareFnDate = (a, b) => {
  let date_a = new Date(a['start_date']);
  let date_b = new Date(b['start_date']);
  if (date_a < date_b) {
    return -1;
  }
  if (date_b > date_a) {
    return 1;
  }
  return 0;
}
const getCountryIconUrl = (name) => {
  let ctr_info = lookup.countries({'ioc': name})[0]
  let alpha2_name = ''
  if(ctr_info){
    alpha2_name = ctr_info["alpha2"]
  }
  if(alpha2_name && alpha2_name.length > 0) {
    return `https://documentstore.ittf.com/websitefiles/assets/flags_normal/${alpha2_name.toLowerCase()}.png`
  } else {
    return '../../assets/icon.png'
  }
}

const getPlayerIconUrl = (id, name) => {
  const _name = name.replace(' ', '_')
  const src = 'https://wttsimfiles.blob.core.windows.net/wtt-media/photos/400px/'

  const src1 = `${src}${id}_Headshot_R_${_name}.png`
  // const src2 = `${src}${id}_HEADSHOT_R_${_name}.png`
  // if(checkImgExists(src1)) {
  //   console.log(_name,1)
  //   return src1
  // } else if(checkImgExists(src2)) {
  //   console.log(_name,2)
  //   return src2
  // }
  return src1
  // return checkImgExists(src1)?src1:src2
  // return '../../assets/icon.png'
}

export default {
  checkImgExists,
  getCountryIconUrl,
  getPlayerIconUrl,
  compareFnDate
}
